import { StorageOverviewMockData } from "./types";

export const storageOverviewMock: StorageOverviewMockData = {
  bucketSize: 1098,
  objects: 2626646144,
  averageSize: 1.30,
};